import KYCInProgress from "../../assets/shieldTickInProgressYellow.svg";
import KYCDefault from "../../assets/shieldTickYellow.svg";
import KYCVerified from "../../assets/shieldGreen.svg";
import KYCFailed from "../../assets/shieldRed.svg";
import { PublicKey } from "@solana/web3.js";
import { RestrictionLocationOptions } from "../enums/civic.enum";
import { CIVIC_NON_US, CIVIC_US } from "../../solana/common/utilities";

export const RestrictionOptionsMap = {
  [RestrictionLocationOptions.AllCountries]: {
    label: "All Countries",
    gatekeeperNetwork: new PublicKey(CIVIC_NON_US),
  },
  [RestrictionLocationOptions.OnlyUS]: {
    label: "Only US citizens",
    gatekeeperNetwork: new PublicKey(CIVIC_US),
  },
  [RestrictionLocationOptions.ProhibitUS]: {
    label: "Prohibit US citizens",
    gatekeeperNetwork: new PublicKey(CIVIC_NON_US),
  },
};

export const KYCStatusesMap = {
  UNKNOWN: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  CHECKING: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  NOT_REQUESTED: {
    label: "KYC Verification",
    buttonLabel: "Start verification via Civic",
    icon: KYCDefault,
  },
  COLLECTING_USER_INFORMATION: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  PROOF_OF_WALLET_OWNERSHIP: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  IN_REVIEW: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  REJECTED: {
    label: "KYC Failed",
    buttonLabel: "Start verification via Civic",
    icon: KYCFailed,
  },
  REVOKED: {
    label: "KYC Revoked",
    buttonLabel: "Start verification via Civic",
    icon: KYCFailed,
  },
  FROZEN: {
    label: "KYC Frozen",
    buttonLabel: "Start verification via Civic",
    icon: KYCFailed,
  },
  ACTIVE: {
    label: "KYC Verified",
    buttonLabel: "",
    icon: KYCVerified,
  },
  ERROR: {
    label: "KYC Failed",
    buttonLabel: "Start verification via Civic",
    icon: KYCFailed,
  },
  LOCATION_NOT_SUPPORTED: {
    label: "KYC Location not supported",
    buttonLabel: "Start verification via Civic",
    icon: KYCDefault,
  },
  VPN_NOT_SUPPORTED: {
    label: "KYC VPN not supported",
    buttonLabel: "Start verification via Civic",
    icon: KYCDefault,
  },
  REFRESH_TOKEN_REQUIRED: {
    label: "Refresh token required",
    buttonLabel: "Refresh",
    icon: KYCInProgress,
  },
  VALIDATING_USER_INFORMATION: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  USER_INFORMATION_VALIDATED: {
    label: "KYC in progress",
    buttonLabel: "Start verification via Civic",
    icon: KYCInProgress,
  },
  USER_INFORMATION_REJECTED: {
    label: "KYC failed",
    buttonLabel: "Start verification via Civic",
    icon: KYCFailed,
  },
};
